// components/CartHeader.jsx

export function CartHeader() {
  return (
    <>
      <button className="continue-top">← Continue Shopping</button>
      <h1 className="cart-title">Your Cart</h1>
    </>
  );
}
